export default {
    dependencies: ['$element', 'bannerastservice', 'radio'],
    callable(element, bannerastService, radio) {
        const bannerEles = Array.from(
            element.querySelectorAll('[data-astbanner-name]')
        );
        bannerastService.showHorseShoe(bannerEles);

        radio('banner-reload-static').subscribe(() => {
            bannerastService.showHorseShoe(bannerEles);
        });
    },
};



// WEBPACK FOOTER //
// ./controllers/bannerHorseShoe.js